import { render, staticRenderFns } from "./PanelLocation.vue?vue&type=template&id=797b72a2&"
import script from "./PanelLocation.vue?vue&type=script&lang=js&"
export * from "./PanelLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports